import React from 'react';
import '../../../css/artist/chats/ArtistEventNotes.css';
import ChatNotesPanel from '../../common/chat/notes/ChatNotesPanel';

const API_URL = process.env.REACT_APP_API_URL;

const ArtistGroupNotesPanel = ({ threadId, onModeChange, onNotesChanged }) => (
  <ChatNotesPanel
    ownerId={threadId}
    rootClassName="artist-notes-panel"
    title="ノート"
    buildListUrl={(ownerId, offset = 0, limit = 20) => `${API_URL}/api/artist/group-chat-notes/${ownerId}?offset=${offset}&limit=${limit}`}
    createUrl={`${API_URL}/api/artist/group-chat-notes`}
    buildUpdateUrl={(noteId) => `${API_URL}/api/artist/group-chat-notes/${noteId}`}
    buildDeleteUrl={(noteId) => `${API_URL}/api/artist/group-chat-notes/${noteId}`}
    buildDetailUrl={(noteId) => `${API_URL}/api/group-chat-notes/detail/${noteId}`}
    onModeChange={onModeChange}
    onNotesChanged={onNotesChanged}
    openDetailEventName="artist-group-notes-open-detail"
    closeDetailEventName="artist-group-notes-close-detail"
    closeImageEventName="artist-group-notes-close-image"
  />
);

export default ArtistGroupNotesPanel;
